import { useState } from "react";


export type MeasuresManager = {
    showElectricalDisconnectionChecklistModal: boolean;
    showElectricFenceChecklistModal: boolean;
    showTake2ChecklistModal: boolean;
    showWorkOnRoadChecklistModal: boolean;
    showConstructionPowerChecklistModal: boolean;

    setShowElectricalDisconnectionChecklistModal: (show: boolean) => void;
    setShowElectricFenceChecklistModal: (show: boolean) => void;
    setShowTake2ChecklistModal: (show: boolean) => void;
    setShowWorkOnRoadChecklistModal: (show: boolean) => void;
    setShowConstructionPowerChecklistModal: (show: boolean) => void;
};

export default function useMeasures(): MeasuresManager {
    const [showElectricalDisconnectionChecklistModal, setShowElectricalDisconnectionChecklistModal] = useState(false);
    const [showElectricFenceChecklistModal, setShowElectricFenceChecklistModal] = useState(false);
    const [showTake2ChecklistModal, setShowTake2ChecklistModal] = useState(false);
    const [showWorkOnRoadChecklistModal, setShowWorkOnRoadChecklistModal] = useState(false);
    const [showConstructionPowerChecklistModal, setShowConstructionPowerChecklistModal] = useState(false);

    return {
        showElectricalDisconnectionChecklistModal,
        showElectricFenceChecklistModal,
        showTake2ChecklistModal,
        showWorkOnRoadChecklistModal,
        showConstructionPowerChecklistModal,
        setShowElectricalDisconnectionChecklistModal,
        setShowElectricFenceChecklistModal,
        setShowTake2ChecklistModal,
        setShowWorkOnRoadChecklistModal,
        setShowConstructionPowerChecklistModal
    };
}

